import axios from 'axios'

const getAccess = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/dash/access`)
  return data
}

export {
  getAccess
}
